import { render, staticRenderFns } from "./RsaRiepiloghiPage.vue?vue&type=template&id=c02c308a&scoped=true"
import script from "./RsaRiepiloghiPage.vue?vue&type=script&lang=js"
export * from "./RsaRiepiloghiPage.vue?vue&type=script&lang=js"
import style0 from "./RsaRiepiloghiPage.vue?vue&type=style&index=0&id=c02c308a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02c308a",
  null
  
)

export default component.exports